


export const MANAGE_SKILL = 'MANAGE_SKILL';
export const GET_MANAGE_SKILL = `${MANAGE_SKILL}/getManageSkillAction`;
export const SET_MANAGE_SKILL = `${MANAGE_SKILL}/setSaveSkillsManageAction`;
export const DELETE_MANAGE_SKILL = `${MANAGE_SKILL}/deleteManageSkllsAction`;
export const GET_MANAGE_SKILLSDATA = `${MANAGE_SKILL}/getManageSkillsAction`;
